import clsx from "clsx";

import { ImageLegacy } from "@/components/displays";
import { FEATURE_FLAG } from "@/configs/system";

import styles from "./FreeShippingHeader.module.scss";

export function FreeShippingHeader(): React.ReactNode {
  if (!FEATURE_FLAG.isFreeShippingCampaignActive) return null;

  return (
    <div className="container">
      <div className="row">
        <div className={clsx(styles.logoPadding, "col-12 text__center")}>
          <ImageLegacy
            src="https://asset.basefood.co.jp/images/logo/logo-color.svg"
            alt="BASE FOOD ベースフード株式会社"
            size={{ width: 182, height: 30 }}
          />
        </div>
      </div>
    </div>
  );
}
